var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dropdown',{attrs:{"splitButton":_vm.splitButton,"tabindex":_vm.tabindex,"size":_vm.size,"trigger":_vm.trigger,"placement":_vm.placement},on:{"click":_vm.handleClick,"command":_vm.handleCommand}},[_c('span',{staticStyle:{"cursor":"pointer"}},[_vm._v("\n    "+_vm._s(_vm.text)),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_vm._t("default",null,{"slot":"dropdown"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4f04720a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./UI/Dropdown/index.vue
// module id = 697
// module chunks = 0